<script setup lang="ts">
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch } from 'vue'
import _, { isNumber } from 'lodash'
import ListingDetail from '@/modules/realestate/views/ListingDetail.vue'
import { ContractListActionTypes, useContractListStore } from '@/modules/contract/stores/contract.list.store.ts'
import ContractDetailForm from '@/modules/contract/components/ContractDetailForm.vue'
import ContractDetailPage from '@/modules/contract/views/ContractDetailPage.vue'
import { useQueryParam } from '@/composables/useQueryParam.ts'
import { useContractDetailStore } from '@/modules/contract/stores/contract.detail.store.ts'
import { useReactiveQueryParam } from '@/composables/useReactiveQueryParam.ts'


const router = useRouter()
const listingListStore = useContractListStore()
const listingDetailStore = useContractDetailStore()


const pageTabs = computed(() => {
  return listingListStore.tabs
})
const displayTabContent = computed(() => {
  return listingListStore.tabs?.find(tab => tab.active)?.id || 'list'
})
const TableConfig = computed(() => {
  return listingListStore.tableConfig
})
const filter = computed(() => {
  return listingListStore.filter
})
const loading = computed(() => {
  return listingListStore.action_type == ContractListActionTypes.FETCHING
})
const page = computed(() => {
  return listingListStore.page
})
const pageSize = computed(() => {
  return listingListStore.pageSize
})
const dataSource = computed(() => {
  return listingListStore.data
})

const handleChangeTab = (tab: any) => {

  listingListStore.changeTab(tab.id)
}

const handleCloseTab = (tab: any) => {

  listingListStore.closeTab(tab.id)
}

const handleCloseAllTab = () => {
  listingListStore.closeAllTab()
}

const handleChangePage = (page: number) => {

  listingListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  listingListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  listingListStore.setFilter(filter)
}

const handleRowDblClick = (e: MouseEvent, item: any) => {

  listingListStore.newTab({id: item.id, label: `#${item.code}`, active: true})
}

const handleRowClick = (e: MouseEvent, item: any) => {

}

const handleChangeSelectedRow = (ids: Array<string|number>) => {

}

const handleSort = (field: string, direction: string) => {

  listingListStore.toggleSort(field, direction)
}

const requestFetchAccountList = _.debounce(async () => {
  try{
    const res = await listingListStore.fetchList()
  } catch (e) {

  }
}, 500)

const detailId = useReactiveQueryParam('detailId')
const setDetailTab = async () => {
  if(parseInt(detailId.value || 0)){
    try {
      const data = await listingDetailStore.fetchDetail(parseInt(detailId.value))
      listingListStore.newTab({id: data.id, label: `#${data.code}`, active: true})
    } catch (e: any) {

    }
  }
}


watch(()=> listingListStore.uuid, (newVal, oldVal) => {
  requestFetchAccountList()
})

onMounted(() => {
  requestFetchAccountList()
  listingListStore.changeTab('list')
  // if(detailId) setDetailTab()
})

watch(()=>detailId, (val) => {

  if(val.value) setDetailTab()
}, {immediate: true})
</script>

<template>
  <dashboard-layout currentRoute="contracts/list" page-title="Quản lý hợp đồng" :tabs="pageTabs" :tabsEvent="{
    close: handleCloseTab,
    select: handleChangeTab,
    closeAll: handleCloseAllTab
  }">
    <template v-if="displayTabContent == 'list'">
      <filter-list
        :filter="filter"
        @update:filter="handleUpdateFilter"
      />
      <data-table
        :loading="loading"
        :tableConfig="TableConfig"
        :page-size="pageSize"
        :page="page"
        :total-page="dataSource?.totalPage || 0"
        :total-records="dataSource?.totalRecords || 0"
        :data="dataSource?.list || []"
        :row-action-buttons="[
          {
            action: handleRowDblClick,
            css: 'btn btn-cs',
            label: 'Chi tiết',
            icon: 'iconamoon:edit-duotone',
            perm: 'contract.detail',
          }
        ]"
        :buttons="[
          {
            label: 'Thêm hợp đồng',
            icon: 'gridicons:create',
            class: 'btn bg-primary bg-hover-primary text-white',
            action: () => {
              router.push({ name: 'contracts-create' })
            },
            perm: 'contract.create',
          },
        ]"
        primaryField="code"
        @page-changed="handleChangePage"
        @pagesize-changed="handleChangePageSize"
        @toggle-visibility="listingListStore.toggleColumnVisibility"
        @on-selected-row="handleChangeSelectedRow"
        @on-sort="handleSort"

      />
    </template>
    <template v-else>
      <template v-for="tab in pageTabs">
        <template v-if="tab.id == displayTabContent">
          <panel :key="tab.id">
            <contract-detail-page :contract-id="tab.id"/>
          </panel>
        </template>
      </template>
    </template>
  </dashboard-layout>
</template>

<style scoped></style>
